import SearchableColumnSelect from "./SearchableColumnSelect";

export default function ColumnMappingRow({
  mapping,
  index,
  file2Cols = [],
  rules = [],
  editable = true,
  updateMapping,
  moveTop,
  moveUp,
  moveDown,
  removeRow,
}) {
  const ruleName =
    rules.find(
      (r) => r.id === mapping.transformRuleId
    )?.ruleName || "-";

  return (
    <tr
      className={`border-t text-center hover:bg-slate-50 ${
        mapping.isMaster ? "bg-blue-50" : ""
      }`}
    >
      {/* SOURCE */}
      <td className="px-4 py-2 text-left font-medium sticky left-0  bg-white">
        {mapping.sourceColumn}
      </td>

      {/* ARROW */}
      <td className="text-blue-500">→</td>

      {/* TARGET */}
      <td className="px-2 py-2">
        {editable ? (
          <SearchableColumnSelect
            value={mapping.targetColumn}
            options={file2Cols}
            onChange={(value) =>
              updateMapping(
                index,
                "targetColumn",
                value
              )
            }
          />
        ) : (
          <span>{mapping.targetColumn || "-"}</span>
        )}
      </td>

      {/* UNIQUE */}
      <td>
        <input
          type="checkbox"
          checked={mapping.isUnique || false}
          disabled={!editable}
          onChange={() =>
            updateMapping(index, "isUnique")
          }
        />
      </td>

      {/* DISPLAY NAME */}
      <td>
        <input
          type="checkbox"
          checked={mapping.displayName || false}
          disabled={!editable}
          onChange={() =>
            updateMapping(
              index,
              "displayName"
            )
          }
        />
      </td>

      {/* PAYMENT PARTY */}
      <td>
        <input
          type="checkbox"
          checked={
            mapping.isInvoiceLevel || false
          }
          disabled={!editable}
          onChange={() =>
            updateMapping(
              index,
              "isInvoiceLevel"
            )
          }
        />
      </td>

      {/* FINAL OUTPUT */}
      <td>
        <input
          type="checkbox"
          checked={
            mapping.finalOutput || false
          }
          disabled={!editable}
          onChange={() =>
            updateMapping(
              index,
              "finalOutput"
            )
          }
        />
      </td>

      {/* MASTER */}
      <td>
        <input
          type="checkbox"
          checked={mapping.isMaster || false}
          disabled={!editable}
          onChange={() =>
            updateMapping(index, "isMaster")
          }
        />
      </td>

      {/* INPUT COLUMN */}
      <td>
        <input
          type="checkbox"
          checked={
            mapping.inputColumn || false
          }
          disabled={!editable}
          onChange={() =>
            updateMapping(
              index,
              "inputColumn"
            )
          }
        />
      </td>

      {/* CUSTOM COLUMN */}
      <td>
        <input
          type="checkbox"
          checked={
            mapping.customColumn || false
          }
          disabled={!editable}
          onChange={() =>
            updateMapping(
              index,
              "customColumn"
            )
          }
        />
      </td>

      {/* OUTPUT COLUMN */}
      <td>
        <input
          type="checkbox"
          checked={
            mapping.outputColumn || false
          }
          disabled={!editable}
          onChange={() =>
            updateMapping(
              index,
              "outputColumn"
            )
          }
        />
      </td>

      {/* DATA TYPE */}
      <td>
        {editable ? (
          <select
            value={mapping.dataType || "String"}
            onChange={(e) =>
              updateMapping(
                index,
                "dataType",
                e.target.value
              )
            }
            className="bg-slate-100 px-2 py-1 rounded"
          >
            <option value="String">
              String
            </option>
            <option value="Number">
              Number
            </option>
            <option value="Date">
              Date
            </option>
          </select>
        ) : (
          <span>{mapping.dataType}</span>
        )}
      </td>

      {/* ALLOWED DIFF */}
      <td>
        {editable ? (
          <input
            type="number"
            disabled={
              mapping.dataType !== "Number"
            }
            value={
              mapping.allowedDiff ?? 0
            }
            onChange={(e) =>
              updateMapping(
                index,
                "allowedDiff",
                e.target.value
              )
            }
            className="w-16 border rounded px-1 py-1 text-center"
          />
        ) : (
          <span>
            {mapping.allowedDiff ?? "-"}
          </span>
        )}
      </td>

      {/* TRANSFORM RULE */}
      <td>
        {editable ? (
          <select
            className="bg-slate-100 px-2 py-1 rounded w-full"
            value={
              mapping.transformRuleId || ""
            }
            onChange={(e) =>
              updateMapping(
                index,
                "transformRuleId",
                e.target.value
              )
            }
          >
            <option value="">
              Select
            </option>

            {rules.map((rule) => (
              <option
                key={rule.id}
                value={rule.id}
              >
                {rule.ruleName}
              </option>
            ))}
          </select>
        ) : (
          <span>{ruleName}</span>
        )}
      </td>

      {/* ACTIONS */}
      {editable &&  (
        <td>
          <div className="flex justify-center gap-2">
            <button
              onClick={() => moveTop(index)}
              title="Move Top"
              className="hover:text-blue-600"
            >
              ⬆
            </button>

            <button
              onClick={() => moveUp(index)}
              title="Move Up"
              className="hover:text-blue-600"
            >
              ↑
            </button>

            <button
              onClick={() =>
                moveDown(index)
              }
              title="Move Down"
              className="hover:text-blue-600"
            >
              ↓
            </button>

            <button
              onClick={() =>
                removeRow(index)
              }
              title="Delete"
              className="text-red-500 hover:text-red-700"
            >
              ❌
            </button>
          </div>
        </td>
      )}
    </tr>
  );
}